import { render, staticRenderFns } from "./NrcDelegateAutocomplete.vue?vue&type=template&id=62323920&"
import script from "./NrcDelegateAutocomplete.vue?vue&type=script&setup=true&lang=js&"
export * from "./NrcDelegateAutocomplete.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports